import { Field, ID, ObjectType } from 'type-graphql'
import type { IOption } from './Option'
import { Option } from './Option'

/**
 * We can use this as the type for Specification, and the class below is for data transfer object purpose
 */
export interface ISpecificationInputProps extends Record<any, any> {
  options: IOption[]
}

export interface ISpecification {
  _id?: string
  name: string
  description: string
  input: string
  inputProps: ISpecificationInputProps
  isPublic: boolean
}

@ObjectType()
export class SpecificationInputProps implements ISpecificationInputProps {
  @Field(() => Option, { nullable: true })
  options: IOption[]
}

@ObjectType()
export class Specification implements ISpecification {
  @Field(() => ID)
  _id?: string

  @Field(() => String, { nullable: true })
  name: string

  @Field(() => String, { nullable: true })
  description: string

  @Field(() => String, { nullable: true })
  input: string

  @Field(() => SpecificationInputProps, { nullable: true })
  inputProps: ISpecificationInputProps

  @Field(() => Boolean, { nullable: true })
  isPublic: boolean
}
